/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, use, withMemo } from 'fierry/react';

import Time from 'solis/time';


const Background = styled.polygon`
  fill: ${props => getFill(props)};
`;


const getFill = ({ band }) =>
{
  return band ? `var(--accent-a${band + 1})` : 'transparent';
};


const getPolygonPoints = ({ hexGeometry, zoneGeometry }) =>
{
  const callback = ({ x, y }) => `${x},${y}`;

  return zoneGeometry.getOutlinePoints().map(callback).join(' ');
};


const Component = withMemo(props =>
(
  <Background {...props} points = {getPolygonPoints(props)} />
));


export default (props) =>
{
  const now = use(Time.Coarse);

  return <Component {...props} band = {props.zoneData.getBackgroundBand(now)} />;
}
